/* eslint-disable react/jsx-props-no-spreading */
import { InputMask } from 'react-tiny-mask'
import TextInput from 'components/TextInput'

// default InputMask tokens prop = { '#': { pattern: /\d/ } }
const VerificationCodeInput = ({ onChange, length = 6, mask = '######', placeholder = '_ _ _ _ _ _', ...rest }) => {
  const onChangeWrapper = (event) => onChange(event.target.value.replace(/\s/g, ''))

  return (
    <TextInput
      {...rest}
      onChange={onChangeWrapper}
      tag={InputMask}
      mask={mask}
      placeholder={placeholder}
      length={length}
    />
  )
}

VerificationCodeInput.propTypes = InputMask.propTypes

export default VerificationCodeInput
